export const mockData = {
  company: {
    name: "Mardhi Adequações",
    description: "Há mais de uma década no mercado, a Mardhi Adequações é reconhecida pela excelência no fornecimento de peças para caminhões. Oferecemos soluções completas para sistemas hidráulicos e componentes essenciais, sempre com foco na qualidade e satisfação do cliente.",
    features: [
      {
        title: "Peças Originais e Compatíveis",
        description: "Trabalhamos apenas com peças de alta qualidade, originais e compatíveis, garantindo performance e durabilidade."
      },
      {
        title: "Atendimento Especializado",
        description: "Nossa equipe possui conhecimento técnico especializado para orientar você na escolha da peça certa."
      },
      {
        title: "Entrega Rápida",
        description: "Logística eficiente para entrega ágil das peças, minimizando o tempo de parada do seu caminhão."
      },
      {
        title: "Suporte Técnico",
        description: "Oferecemos suporte técnico completo para instalação e manutenção das peças fornecidas."
      }
    ]
  },
  
  stats: {
    experience: "10+",
    customers: "500+", 
    parts: "1000+",
    satisfaction: "98%"
  },

  services: [
    {
      title: "Sistema Hidráulico",
      description: "Equipamentos e componentes para sistemas hidráulicos completos de caminhões.",
      icon: "Wrench",
      items: [
        "Tomada de força",
        "Kit hidráulico completo",
        "Bomba hidráulica",
        "Mangueiras hidráulicas e prensadas",
        "Conexão hidráulica em geral",
        "Cilindros hidráulicos"
      ]
    },
    {
      title: "Peças e Acessórios",
      description: "Peças e componentes diversos para manutenção e adequação de caminhões.",
      icon: "Settings",
      items: [
        "Pára-lama/suporte",
        "Peças de carroceria",
        "Componentes de implementos",
        "Acessórios para basculantes",
        "Peças de reposição",
        "Suportes e fixações"
      ]
    },
    {
      title: "Serviços Especializados",
      description: "Serviços técnicos especializados em adequações e instalações hidráulicas.",
      icon: "Truck",
      items: [
        "Instalação de sistemas hidráulicos",
        "Prensagem de mangueiras",
        "Adequações veiculares",
        "Manutenção preventiva",
        "Consultoria técnica",
        "Suporte pós-venda"
      ]
    }
  ],

  contact: {
    address: "Avenida Brigadeiro Eduardo Gomes, 250 - Loja 02\nJardim Limoeiro, Serra - ES, 29164-050",
    phone: "(27) 99693-9202",
    phone2: "(27) 3051-2618",
    email: "mardhiadequequacoes@gmail.com", 
    hours: "Segunda a Sexta: 8h às 17h30\nSábado: 8h às 12h\nDomingo: Fechado"
  }
};